import styled from 'styled-components';
import dt from '../../../shared/theme';
import { darken } from '../../../shared/color';

// eslint-disable-next-line import/prefer-default-export
export const Notice = styled.div`
  padding: 8px;
  margin: 9 -3px 0 3px;
  background-color: transparent;
  text-align: center;
  color: ${props => darken(dt(props).theme.secondaryColor, 10)};
`;
